import React from 'react';
import useTranslate from '../../hooks/useTranslate';
import useAuthenticationStore from './Store';
import "./CookiesBanner.css"

const CookiesBanner: React.FC = () => {
  const { isCookiesBannerVisible, hideCookiesBanner } = useAuthenticationStore()
  const translations = useTranslate(["participant-login-cookies-banner-message"])

  if (isCookiesBannerVisible()) {
    return (
      <div className="cookies-banner">
        <div className="cookies-banner-message" dangerouslySetInnerHTML={{ __html: translations['participant-login-cookies-banner-message'] }} />
        <div className="hide-banner-icon-container" onClick={hideCookiesBanner}>
          <i className="fa fa-times hide-banner-icon"></i>
        </div>
      </div>
    )
  }
  return null
}

export default CookiesBanner